import React, { useEffect, useState } from "react";
import LogoContainer from "../components/logoContainer";
import { showSidebarCollapseFunction, hideSidebarCollapseFunction } from "../components/SidebarFunctions";
import ElectronicBillingIndex from "./electronicBillingContent/ElectronicBillingIndex"; 
import CreditNoteIndex from "./electronicBillingContent/CreditNoteIndex";
import InvoiceData from "./electronicBillingContent/InvoiceData";
import { useLocation } from 'react-router-dom';
import SidebarElectronicBilling from "../components/SidebarElectronicBilling";
import Products from "./electronicBillingContent/Products";
import PriceList from "./electronicBillingContent/PriceList";
import ImportProducts from "./electronicBillingContent/ImportProducts";
import PropTypes from 'prop-types';
import { windowHistoryReplaceState } from "../components/mainFunctions";
import ElectronicDocument from "./electronicBillingContent/ElectronicDocument"; 
import Configs from "./electronicBillingContent/Configs";
import Management from "./electronicBillingContent/Management";
import Statistics from "./electronicBillingContent/Statistics";
import InvoiceNumberInvalidate from "./electronicBillingContent/InvoiceNumberInvalidate";
import { modalForbidden } from "../components/DefaultAjax";

const adminOnlyPaths = new Set([
    "/ElectronicBilling/CreditNote",
    "/ElectronicBilling/Faq",
    "/ElectronicBilling/PriceList",
    "/ElectronicBilling/ImportProducts",
    "/ElectronicBilling/ElectronicDocument",
    "/ElectronicBilling/InvoiceNumberInvalidate",
    "/ElectronicBilling/Configs",
    "/ElectronicBilling/Management",
    "/ElectronicBilling/Statistics"
]);

const getIsAdmin = () => {
    const element = document.querySelector("#isAdmin");
    if (!element || element.value === "") {
        return null;
    }
    return element.value === "true";
};

const electronicBillingContentByPath = {
    "/": ({token, independent, instanceType, language}) => (
        <ElectronicBillingIndex token={token} independent={independent} instanceType={instanceType} language={language} />
    ),
    "/ElectronicBilling/ElectronicBillingIndex": ({token, independent, instanceType, language}) => (
        <ElectronicBillingIndex token={token} independent={independent} instanceType={instanceType} language={language} />
    ),
    "/ElectronicBilling": ({token, independent, instanceType, language}) => (
        <ElectronicBillingIndex token={token} independent={independent} instanceType={instanceType} language={language} />
    ),
    "/ElectronicBilling/CreditNote": ({token}) => <CreditNoteIndex token={token} />,
    "/ElectronicBilling/Faq": ({token}) => <InvoiceData token={token} />,
    "/ElectronicBilling/Products": ({token}) => <Products token={token} />,
    "/ElectronicBilling/PriceList": ({token}) => <PriceList token={token} />,
    "/ElectronicBilling/ImportProducts": ({token}) => <ImportProducts token={token} />,
    "/ElectronicBilling/ElectronicDocument": ({token, language}) => <ElectronicDocument token={token} language={language}/>,
    "/ElectronicBilling/InvoiceNumberInvalidate": ({token}) => <InvoiceNumberInvalidate token={token} />,
    "/ElectronicBilling/Configs": ({token}) => <Configs token={token} />,
    "/ElectronicBilling/Management": ({token}) => <Management token={token} />,
    "/ElectronicBilling/Statistics": ({token}) => <Statistics token={token} />
};

const getElectronicBillingContent = (url, isAdmin, contentProps) => {
    const isAdminOnlyPath = adminOnlyPaths.has(url);
    if (isAdminOnlyPath && isAdmin === null) {
        return "";
    }
    if (isAdminOnlyPath && !isAdmin) {
        return modalForbidden();
    }

    const renderContent = electronicBillingContentByPath[url];
    return renderContent ? renderContent(contentProps) : "";
};

const ElectronicBilling = ({language,token, instanceType, independent}) => {
    const [isAdmin, setIsAdmin] = useState(getIsAdmin());

    useEffect(() => {
        const syncAdminState = () => {
            const currentIsAdmin = getIsAdmin();
            if (currentIsAdmin !== null) {
                setIsAdmin(currentIsAdmin);
                return true;
            }
            return false;
        };

        if (syncAdminState()) {
            return undefined;
        }

        const intervalId = setInterval(() => {
            if (syncAdminState()) {
                clearInterval(intervalId);
            }
        }, 100);
        return () => clearInterval(intervalId);
    }, []);
    
    const url = useLocation().pathname;
    const content = getElectronicBillingContent(url, isAdmin, {token, independent, instanceType, language});

    windowHistoryReplaceState(independent,instanceType);

    let flag = 0;
	const showSidebarCollapse = () => {
        
        if(document.querySelector(".sidebar2Collapse")){
            showSidebarCollapseFunction();
            flag = 1;
        }
	} 
    const hideSidebarCollapse = () => {
        if(flag === 1){
            hideSidebarCollapseFunction();
            flag = 0;
        } 
    }
    

    return (
        <div className="tab-pane fade" id="nav-controlElectronicBilling" role="tabpanel" aria-labelledby="nav-controlElectronicBilling-tab" style={{opacity: 1}}>
            <div className="sidebar2"  onMouseOver={showSidebarCollapse} onMouseOut={hideSidebarCollapse}>
                <LogoContainer/>
                <SidebarElectronicBilling isAdmin={isAdmin === true}/>
            </div>
            
            <div className="content" id="contentElectronicBilling">
                {content}
            </div>
        </div>
    );

} 

ElectronicBilling.propTypes = {
    token: PropTypes.string.isRequired, 
    independent: PropTypes.string.isRequired, 
    instanceType: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired
};

export default ElectronicBilling;
